import Storage from '../Util/Storage';

export class InspireOptions {
  isAdmin: boolean;
  isTm: boolean;
  isOm: boolean;
  isExclusivelyOm: boolean;
  enableCesComments: boolean;
  enableCoachingNotes: boolean;
  userID: string;
  cscEntityPrefix: string;
  requesterUserID: string;
  requesterUsername: string;
  requesterOwner: string;
  manageCoachingNotes: boolean;
  isExclusivelyTm: boolean;

  constructor({
    isAdmin,
    isTm,
    isOm,
    isExclusivelyOm,
    enableCesComments,
    enableCoachingNotes,
    userID,
    cscEntityPrefix,
    requesterUserID,
    requesterUsername,
    requesterOwner,
    manageCoachingNotes,
  }: Record<string, any>) {
    this.isAdmin = isAdmin;
    this.isTm = isTm;
    this.isOm = isOm;
    this.isExclusivelyOm = isExclusivelyOm;
    this.enableCesComments = enableCesComments;
    this.enableCoachingNotes = enableCoachingNotes;
    this.userID = userID;
    this.cscEntityPrefix = cscEntityPrefix;
    this.requesterUserID = requesterUserID;
    this.requesterUsername = requesterUsername;
    this.requesterOwner = requesterOwner;
    this.manageCoachingNotes = manageCoachingNotes;
    this.isExclusivelyTm = isTm && !isOm;
    // This will store the case sensitive ownername from getInspireOptions
    // to be set as header x-go-owner for the backend resolvers
    Storage.setItem('requesterOwner', this.requesterOwner);
  }
}

export const EmptyInspireOptions: InspireOptions = {
  isAdmin: false,
  isTm: false,
  isOm: false,
  isExclusivelyOm: false,
  enableCesComments: false,
  enableCoachingNotes: false,
  userID: '',
  cscEntityPrefix: '',
  requesterUserID: '',
  requesterUsername: '',
  requesterOwner: '',
  manageCoachingNotes: false,
  isExclusivelyTm: false,
};
